import ErrorBoundary from './ErrorBoundary';
import ScrollToTopOnMount from './ScrollToTopOnMount';
import {
  Toggler,
  ImageWithBlur,
  WhitePanel,
  SemiTransparentLoader,
} from './UI';
import { LodgeCard, GuideCard } from './Cards';
import Page from './Page';
import Loading from './Loading';
import CardsSlider from './CardsSlider';
import Promocode from './Promocode';
import Prices from './Prices';

export {
  ErrorBoundary,
  ScrollToTopOnMount,
  Toggler,
  ImageWithBlur,
  Loading,
  WhitePanel,
  LodgeCard,
  SemiTransparentLoader,
  Page,
  CardsSlider,
  GuideCard,
  Promocode,
  Prices,
};



// WEBPACK FOOTER //
// ./src/components/index.js